import { render, staticRenderFns } from "./downLoadZip.vue?vue&type=template&id=db571370&scoped=true"
import script from "./downLoadZip.vue?vue&type=script&lang=js"
export * from "./downLoadZip.vue?vue&type=script&lang=js"
import style0 from "./downLoadZip.vue?vue&type=style&index=0&id=db571370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db571370",
  null
  
)

export default component.exports